module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_about-41527fb5a2ec83dc236de6ba6b665971.png";